export type WaypointCoordinateLike = {
  latitude?: string | number | null;
  longitude?: string | number | null;
};

export const arcWpsPath = (
  wps: WaypointCoordinateLike[] | undefined | null,
): google.maps.LatLngLiteral[] => {
  if (!wps?.length) return [];

  return wps
    .map((wp) => {
      const lat = Number(wp.latitude);
      const lng = Number(wp.longitude);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return { lat, lng };
    })
    .filter((point): point is google.maps.LatLngLiteral => point !== null);
};